<template>
  <div class="send-view">
    <loader v-if="loading" message="Envoi du panier en cours"></loader>

     <div v-if="dataError" class="center-align">
      <p>Les données envoyées sont invalides.</p>
      <div v-for="item in dataError">
        <p v-for="value in item" class="red-text text-darken-2">{{value}}</p>
      </div>
      <button class="btn waves-effect waves-light btn-brico" @click="$router.push('/basket')">Revenir au panier</button>
     </div>

    <div v-if="error" class="center-align">
      <p>Une erreur c'est produite lors de l'envoi de la commande.</p>
      <button class="btn waves-effect waves-light btn-brico" @click="sendData">Réessayer</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "@/components/Loader.vue";

export default {
  data() {
    return {
      loading: null,
      dataError: null,
      error: null
    };
  },
  created: function() {
    this.sendData();
  },
  methods: {
    sendData: function() {
      this.error = false;
      this.loading = true;

      axios
        .post(process.env.VUE_APP_VENTE_URL + "/basket/send", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          },
          civility: this.$store.state.civility,
          client_name: this.$store.state.client_name,
          seller: this.$store.state.seller,
          delivery_type: this.$store.state.delivery_type,
          products: this.$store.state.basket,
          phone: this.$store.state.phone,
          address: this.$store.state.address,
          date: this.$store.state.date,
          mail: this.$store.state.mail
        })
        .then(response => {
          this.$store.commit('erase');
          this.$router.push("/");
          swal({
            title: "Félicitations !",
            text:
              "Votre bon de vente a été envoyé en préparation et en caisse.",
            icon: "success",
            button: "Fermer"
          });
        })
        .catch(error => {
          this.loading = false;
          if (error.response.status === 422){
            this.dataError = error.response.data.errors;
          }
          else{
            this.error = "Une erreur c'est produite lors de l'envoi de la commande."
          }
        });
    }
  },
  components: { Loader }
};
</script>
